<template>
    <div style="display: flex; gap: 8px;">

        <router-link
            :to="'accounting/'+row.id+'/details'"
            class="btn btn-sm btn-clean btn-icon btn-icon-sm" title="مشاهده صورتحساب های بانکی"
        >
            <i class="fa fa-eye"></i>
        </router-link>
        <a class="btn btn-sm btn-clean btn-icon btn-icon-sm" @click.prevent="getDeposits" title="دریافت صورتحساب های بانکی">
            <i class="fa fa-sync"></i>
        </a>
        
        <a v-if="$can('delete-bank-account', 'accounting')" @click.prevent="deleteAccount" class="btn btn-sm btn-clean btn-icon btn-icon-sm"
            title="حذف حساب"
        >
            <i class="fa fa-trash"></i>
        </a>
    </div>
</template>


<script>
import $ from 'jquery';
import Vue from 'vue';
import toastr from 'toastr';
import { accountingService } from "@/common/api.service";
import { i18n } from '@/plugins/i18n'
import { error } from 'jquery';
import { starShopAccountingService } from '../../../common/api.service';

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        activeService() {
            return this.$route.path.includes('pf') ? accountingService : starShopAccountingService;
        },
        selector() {
            return $('tr[data-row="'+this.index+'"');
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            };

            return toastr;
        }
    },
    methods: {
    deleteAccount(e) {
        const confirmed = window.confirm(i18n.t("message.are_you_sure_deleting_this_wallet_bank_account"));
        
        if (confirmed) {
            this.activeService.removeAccount(this.row.id).then(
                response => {
                    this.toastr.success(response.data.message);
                    this.datatable.reload();
                },
                error => {
                    this.toastr.error(error.response.data.message || i18n.t("message.an_error_occurred"));
                }
            );
        } 
    },

    getDeposits(e) {
        this.activeService.getWalletBankAccountDeposits({
            hashid: this.row.id
        }).then(
            response => {
                this.toastr.success(response.data.message);
            },
            error => {
                this.toastr.error(error.response.data.message || i18n.t("message.an_error_occurred"))
            }
        )
    }
},
});
</script>